define(function () {
	'use strict';

	return function () {
		var _canvas = document.createElement('canvas'),
			_context = _canvas.getContext('2d');

		_context.canvas.width = 100;
		_context.canvas.height = 80;


		_context.beginPath();
		_context.moveTo(0, 0);
		_context.lineTo(100, 0);
		_context.lineTo(100, 80);
		_context.lineTo(0, 80);
		_context.closePath();
		_context.clip();
		_context.lineCap = 'butt';
		_context.lineJoin = 'miter';
		_context.miterLimit = 4;
		_context.beginPath();
		_context.moveTo(50, 30);
		_context.bezierCurveTo(41.715, 30,35, 36.718, 35, 45);
		_context.bezierCurveTo(35, 53.285, 41.715, 60, 50, 60);
		_context.bezierCurveTo(58.283, 60, 65, 53.285, 65, 45);
		_context.bezierCurveTo(65, 36.718, 58.283, 30, 50, 30);
		_context.closePath();
		_context.moveTo(90, 15);
		_context.lineTo(78, 15);
		_context.bezierCurveTo(76.35, 15, 74.572, 13.72, 74.051, 12.154);
		_context.lineTo(70.949, 2.8450000000000006);
		_context.bezierCurveTo(70.426, 1.28, 68.65, 0, 67, 0);
		_context.lineTo(33,  0);
		_context.bezierCurveTo(31.35, 0, 29.572, 1.28, 29.051000000000002, 2.846);
		_context.lineTo(25.949, 12.155);
		_context.bezierCurveTo(25.426, 13.72, 23.65, 15, 22, 15);
		_context.lineTo(10, 15);
		_context.bezierCurveTo(4.5, 15, 0, 19.5, 0, 25);
		_context.lineTo(0, 70);
		_context.bezierCurveTo(0, 75.5, 4.5, 80, 10, 80);
		_context.lineTo(90, 80);
		_context.bezierCurveTo(95.5, 80, 100, 75.5, 100, 70);
		_context.lineTo(100, 25);
		_context.bezierCurveTo(100, 19.5, 95.5, 15, 90, 15);
		_context.closePath();
		_context.moveTo(50, 70);
		_context.bezierCurveTo(36.193, 70, 25, 58.807, 25, 45);
		_context.bezierCurveTo(25, 31.194000000000003, 36.193, 20, 50, 20);
		_context.bezierCurveTo(63.805, 20, 75, 31.194000000000003, 75, 45);
		_context.bezierCurveTo(75, 58.807, 63.805, 70, 50, 70);
		_context.closePath();
		_context.moveTo(86.5, 31.993);
		_context.bezierCurveTo(84.568, 31.993, 83, 30.427, 83, 28.493);
		_context.bezierCurveTo(83, 26.561, 84.568, 24.993, 86.5, 24.993);
		_context.bezierCurveTo(88.434, 24.993, 90, 26.561, 90, 28.493);
		_context.bezierCurveTo(90, 30.427, 88.433, 31.993, 86.5, 31.993);
		_context.closePath();
		_context.fill();
		_context.stroke();


		// public methods

		this.get = function () {
			return _canvas;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/canvas/CameraCanvas.js
// module id = 350
// module chunks = 1